import {MvsCoreService} from "../../../../../core/shared/service/mvs-core.service";
import {MvsCrudService} from "../../../../../core/shared/service/crud/mvs-crud.service";
import {Component, OnInit} from '@angular/core';
import {PageComponent} from "../../../../../core/shared/mvs-page/page.component";
import {ActivatedRoute, Router} from "@angular/router";
import {AgentDto} from "../../../../../feature-core/am/model/dto/entity/agent.dto";
import {WidgetData} from "../../../../../core/shared/widget/widget-data";
import {AgentService} from "../../../../../feature-core/am/service/api/agent.service";
import {FilterCriteria} from "../../../../../core/shared/filter/api/filter.criteria";
import {ObjectRequestList} from "../../../../../core/shared/dto/object/request/object-request-list";
import {WidgetFactory} from "../../../../../core/shared/widget/service/widget.factory";
import {ObjectIdentifierData} from "../../../../../core/shared/basic/object-identifier-data";
import {ObjectIdentifier} from "../../../../../core/shared/basic/object-identifier";


@Component({
    selector: 'cr-my-customers',
    templateUrl: 'my-customers.page.html',
    standalone: false
})
export class MyCustomersPage
  extends PageComponent
  implements OnInit {

    customerAgentService: MvsCrudService;
  loggedOnAgent: AgentDto;

  myRecentCustomersWidget: WidgetData;

  constructor(
        protected coreService: MvsCoreService,
        
    protected override route: ActivatedRoute,
    protected agentService: AgentService,
    private router: Router) {
    super(route, coreService);
  }

  override ngOnInit() {
    super.ngOnInit();


        this.customerAgentService = this.coreService.getCrudService("cr.CustomerAgent");
    this.initComponent()

  }

  initComponent() {

    this.getLoggedOnAgent()
  }


  refreshComponent() {

    this.initialized = true;
  }

  getLoggedOnAgent() {
    this.agentService.me().subscribe(res => {
      this.loggedOnAgent = res;
      this.getAgentCustomers();
      this.refreshComponent()
    });
  }

  getAgentCustomers() {
    const filterCriteria = FilterCriteria.create('agent', FilterCriteria.cOperatorEqual, this.loggedOnAgent.id);


    const objectData = ObjectRequestList.createBasic(true, [filterCriteria], []);
    this.customerAgentService.list(objectData).subscribe(customerAgents => {

      let orFilterCriteria = FilterCriteria.createOrFromArray('id', 'customerDtoId', customerAgents.entries);

      if (!orFilterCriteria || Object.keys(orFilterCriteria).length === 0) {
        orFilterCriteria = FilterCriteria.create('id', FilterCriteria.cOperatorEqual, 0);
      }

      const objectRequestList = ObjectRequestList.createBasic(true, [orFilterCriteria], []);

      this.myRecentCustomersWidget = WidgetFactory.createWidgetTableEntity(
        'cr.page.my-customers.customer-list',
        'Meine Kunden',
        'cr.Customer',
        'Kein Kunden',
        objectRequestList
      );

    });

  }

  handleObjectSelect(object: ObjectIdentifierData | ObjectIdentifier) {
    this.router.navigate(['/cr/customers', object?.objectId]);
  }

}
